interface TaskDueState {
  due_time?: number;
  status: string;
  subtask_summary?: {
    total?: number;
    completed?: number;
    overdue_content_count?: number;
    next_content_due_time?: number;
  };
}

function getLocalCalendarDay(timestamp: number) {
  const date = new Date(timestamp);
  return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
}

export function isTaskEffectivelyCompleted(task: TaskDueState): boolean {
  const total = Number(task.subtask_summary?.total || 0);
  const completed = Number(task.subtask_summary?.completed || 0);
  return (
    task.status === "done" ||
    task.status === "discarded" ||
    (total > 0 && completed >= total)
  );
}

export function getTaskOverdueContentCount(task: TaskDueState): number {
  if (isTaskEffectivelyCompleted(task)) {
    return 0;
  }
  return Math.max(
    0,
    Number(task.subtask_summary?.overdue_content_count || 0)
  );
}

export function getTaskOverdueDays(
  task: TaskDueState,
  now = Date.now()
): number {
  const subtaskTotal = Number(task.subtask_summary?.total || 0);
  const overdueContentCount = getTaskOverdueContentCount(task);
  const effectiveDueTime =
    subtaskTotal > 0
      ? overdueContentCount > 0
        ? Number(task.subtask_summary?.next_content_due_time || 0)
        : 0
      : Number(task.due_time || 0);
  if (
    isTaskEffectivelyCompleted(task) ||
    !Number.isFinite(effectiveDueTime) ||
    effectiveDueTime <= 0
  ) {
    return 0;
  }
  const dayMs = 24 * 60 * 60 * 1000;
  const overdueDays = Math.floor(
    (getLocalCalendarDay(now) - getLocalCalendarDay(effectiveDueTime)) /
      dayMs
  );
  return Math.max(0, overdueDays);
}
